import { render, staticRenderFns } from "./JfOver.vue?vue&type=template&id=8da03c8e&scoped=true&"
import script from "./JfOver.vue?vue&type=script&lang=js&"
export * from "./JfOver.vue?vue&type=script&lang=js&"
import style0 from "./JfOver.vue?vue&type=style&index=0&id=8da03c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da03c8e",
  null
  
)

export default component.exports